import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../UserContext';
import { db } from '../firebase';
import { doc, updateDoc } from 'firebase/firestore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faHandshake, faShare } from '@fortawesome/free-solid-svg-icons';

const OnboardingPage = () => {
  const navigate = useNavigate();
  const { user, updateUserProfile } = useUser();
  const [isLoading, setIsLoading] = useState(false);

  const handleFinishOnboarding = async () => {
    if (!user) {
      console.error("No user found");
      return;
    }

    setIsLoading(true);
    try {
      const userRef = doc(db, "users", user.uid);
      await updateDoc(userRef, {
        onboardingCompleted: true
      });

      // Update the user context
      await updateUserProfile({ onboardingCompleted: true });

      navigate('/');
    } catch (error) {
      console.error("Error updating onboarding status:", error);
      // You might want to show an error message to the user here
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto bg-white rounded-lg shadow-md overflow-hidden">
        <div className="px-6 py-8">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-8">Welcome to the Tremont Garden Tool Share</h2>
          
          <div className="space-y-6">
            <section>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">How It Works</h3>
              <p className="text-gray-600">
                Our app connects neighbors in the Tremont / Westwood community, allowing them to share tools and resources. No ads. Built by a neighbor. No data shared anywhere.<br/><br/> Here's a quick guide to get you started:
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">
                <FontAwesomeIcon icon={faSearch} className="mr-2 text-green-600" />
                Browse Available Tools
              </h3>
              <p className="text-gray-600">
                Explore the catalog of tools and resources shared by community members. Use search & filters to find exactly what you need. 
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">
                <FontAwesomeIcon icon={faHandshake} className="mr-2 text-green-600" />
                Request a Tool
              </h3>
              <p className="text-gray-600">
                Found a tool you need? Simply click on it and submit a borrowing request. The owner will review your request and respond. This is like AirBNB for tools (But free!)
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">
                <FontAwesomeIcon icon={faShare} className="mr-2 text-green-600" />
                Share Your Own Tools
              </h3>
              <p className="text-gray-600">
                Have tools you'd like to share? Add them to the community network on the "My Tools" page. This is just starting, so please add your tools!
              </p>
            </section>
          </div>

          <div className="mt-10">
            <button
              onClick={handleFinishOnboarding}
              disabled={isLoading}
              className={`w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white ${
                isLoading ? 'bg-gray-400 cursor-not-allowed' : 'bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500'
              }`}
            >
              {isLoading ? 'Loading...' : 'Get Started'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnboardingPage;
